module.exports = __webpack_public_path__ + "img/fine1.e09fdf12.png";